// src/queryClient.js
import { QueryClient } from "@tanstack/react-query";

// Create a client with default options
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // How long data stays fresh before refetching (5 minutes)
      staleTime: 1000 * 60 * 5,

      // How long inactive data stays in cache (10 minutes)
      cacheTime: 1000 * 60 * 10,

      // Retry failed requests
      retry: 1,

      // Don't refetch on window focus in development
      refetchOnWindowFocus: process.env.NODE_ENV === "production",

      // Refetch on reconnect
      refetchOnReconnect: true,

      // Show stale data while refetching
      keepPreviousData: true,
    },
    mutations: {
      // Retry failed mutations once
      retry: 1,
    },
  },
});
